import type { AiHubPageContext } from "@/types/ai-agent";
import { ACTION_PLAN_V2 } from "@/components/common/ActionPlanV2/constants";

/** Ngữ cảnh chat Hub → MS.AICoaching nhánh Trợ lý Action Plan V2. */
export function buildActionPlanV2AiPageContext(
  route: string,
  profileId: string,
  year = new Date().getFullYear(),
): AiHubPageContext {
  const idChoice = profileId.trim();
  return {
    route: route.includes("action-plan-v2") ? route : ACTION_PLAN_V2.ROUTE_HOME,
    label: "Action Plan V2",
    idChoice,
    year,
    phanHe: ACTION_PLAN_V2.PHAN_HE,
  };
}
